/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'
import Table from '../../../../components/InternalMenu/TablesList'

import ReactPaginate from 'react-paginate'

import { useNavigate } from 'react-router-dom'

import serverIcon from '../../../../assets/svg/serverIcon.svg'

import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const navigate = useNavigate()
  const [tables, setTables] = useState()
  const [tablesCount, setTablesCount] = useState()
  const [totalPage, setTotalPage] = useState()

  document.title = 'گارسون'

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/im/servers/create_table')
  }

  useEffect(() => {
    get(`/api/admin/im/table?token=${token}`)
      .then(response => {
        setTables(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setTablesCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/im/table?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setTables(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setTablesCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'server'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={serverIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                گارسون
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد میز</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل میزها
              </div>
              <div className="left">
                {tablesCount}
              </div>
            </div>

            <Table data={tables} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
